<template>
  <div id="userLayout" :class="['user-layout-wrapper', isMobile && 'mobile']">
    <div class="container">
      <div class="top">
        <div class="header">
          <a href="/">
            <img src="~@/assets/logo.png" class="logo" alt="logo" />
            <span class="title">{{
              $t('app.setting.houtaiguanlixitong.houtaiguanlixitong')
            }}</span>
          </a>
        </div>
        <div class="desc"></div>
      </div>
      <router-view />
    </div>
  </div>
</template>

<script>
import { deviceMixin } from '@/store/device-mixin'

export default {
  name: 'UserLayout',
  mixins: [deviceMixin],
  mounted() {
    document.body.classList.add('userLayout')
  },
  beforeUnmount() {
    document.body.classList.remove('userLayout')
  },
}
</script>

<style lang="less" scoped>
#userLayout.user-layout-wrapper {
  height: 100%;
  overflow: hidden;
  position: relative;
  &::before {
    content: '';
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: #f5f5f5;
    z-index: 0;
  }

  &.mobile {
    .container {
      .main {
        max-width: 368px;
        width: 98%;
      }
    }
  }

  .container {
    width: 100%;
    min-height: 100vh;
    padding: 0;
    position: relative;
    z-index: 1;

    a {
      text-decoration: none;
      transition: all 0.3s ease;
    }

    .top {
      display: none; // 登录页面有自己的顶部header，隐藏UserLayout的header
      text-align: center;
      margin-bottom: 40px;
      animation: fadeInDown 0.8s ease-out;

      .header {
        height: auto;
        line-height: 1.5;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        padding: 24px 48px;
        background: linear-gradient(
          135deg,
          rgba(255, 255, 255, 0.98) 0%,
          rgba(255, 255, 255, 0.96) 100%
        );
        backdrop-filter: blur(30px) saturate(200%) brightness(1.05);
        -webkit-backdrop-filter: blur(30px) saturate(200%) brightness(1.05);
        border-radius: 24px;
        box-shadow: 0 12px 40px rgba(0, 0, 0, 0.15),
          0 6px 16px rgba(0, 0, 0, 0.1), 0 2px 8px rgba(0, 0, 0, 0.08),
          inset 0 2px 0 rgba(255, 255, 255, 0.7),
          inset 0 -1px 0 rgba(255, 255, 255, 0.4);
        border: 2px solid rgba(255, 255, 255, 0.5);
        transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);

        &:hover {
          transform: translateY(-6px) scale(1.03);
          box-shadow: 0 16px 50px rgba(0, 0, 0, 0.2),
            0 8px 20px rgba(0, 0, 0, 0.15), 0 3px 10px rgba(0, 0, 0, 0.1),
            inset 0 2px 0 rgba(255, 255, 255, 0.8),
            inset 0 -1px 0 rgba(255, 255, 255, 0.5);
        }

        .badge {
          position: absolute;
          display: inline-block;
          line-height: 1;
          vertical-align: middle;
          margin-left: -12px;
          margin-top: -10px;
          opacity: 0.8;
        }

        .logo {
          height: 48px;
          vertical-align: top;
          margin-right: 16px;
          border-style: none;
          filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
          transition: transform 0.3s ease;

          &:hover {
            transform: scale(1.05);
          }
        }

        .title {
          font-size: 32px;
          background: linear-gradient(
            135deg,
            #1890ff 0%,
            #722ed1 50%,
            #eb2f96 100%
          );
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI',
            'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei',
            'Helvetica Neue', Helvetica, Arial, sans-serif;
          font-weight: 700;
          letter-spacing: -0.5px;
          position: relative;
          text-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
        }
      }

      .desc {
        font-size: 15px;
        color: rgba(0, 0, 0, 0.65);
        margin-top: 16px;
        margin-bottom: 0;
        font-weight: 400;
      }
    }

    .main {
      min-width: 260px;
      width: 100%;
      max-width: 420px;
      margin: 0 auto;
      position: relative;
      z-index: 2;
    }

    .footer {
      position: fixed;
      width: 100%;
      bottom: 0;
      padding: 20px 16px;
      text-align: center;
      background: rgba(255, 255, 255, 0.8);
      backdrop-filter: blur(10px);
      border-top: 1px solid rgba(0, 0, 0, 0.06);
      z-index: 1;

      .links {
        margin-bottom: 8px;
        font-size: 14px;
        a {
          color: rgba(0, 0, 0, 0.65);
          transition: all 0.3s;
          &:not(:last-child) {
            margin-right: 40px;
          }
          &:hover {
            color: #1890ff;
            transform: translateY(-1px);
          }
        }
      }
      .copyright {
        color: rgba(0, 0, 0, 0.45);
        font-size: 13px;
      }
    }
  }
}
@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
